<div class="assigned-contacts">
  @if (title) {
    <div class="assigned-contacts__header d-flex align-items-center justify-content-between gap-2">
      <span class="assigned-contacts__title text-truncate">{{ title }}</span>
      @if (!loading) {
        <span class="assigned-contacts__count flex-shrink-0">{{ totalCount ?? contacts.length }}</span>
      }
    </div>
  }

  @if (loading) {
    <div class="assigned-contacts__state d-flex align-items-center justify-content-center">
      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    </div>
  } @else if (contacts.length === 0) {
    <div class="assigned-contacts__state assigned-contacts__state--empty">{{ emptyMessage }}</div>
  } @else {
    <ul class="assigned-contacts__list list-unstyled m-0" (scroll)="onListScroll($event)">
      @for (contact of contacts; track contact.id) {
        <li class="assigned-contacts__item d-flex align-items-center gap-2">
          <i class="pi pi-user assigned-contacts__icon flex-shrink-0" aria-hidden="true"></i>
          <div class="flex-grow-1 min-w-0 lh-sm">
            <div class="assigned-contacts__name text-truncate">{{ contact.fullName }}</div>
            @if (contact.phoneNumber) {
              <div class="assigned-contacts__phone text-truncate">{{ contact.phoneNumber }}</div>
            }
          </div>
        </li>
      }
      @if (loadingMore) {
        <li class="assigned-contacts__more d-flex align-items-center justify-content-center">
          <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        </li>
      }
    </ul>
  }
</div>
